
import React from 'react';
import cn from 'classnames';

import styles from './StatusComponent.module.scss';

export default function StatusComponent(props) {
  return (
    // <div className={`ssddbb ${cn(styles.group, styles.group_layout1)}`}>
      <div id="Status_Card" className={cn(styles.block11, styles.block11_layout)}>
        <div id="Status_Card_Title" className={cn(styles.flex5, styles.flex5_layout)}>
          <h5 id="Status_Heading" className={cn(styles.highlights, styles.highlights_layout)}>
            {props.header}
          </h5>
          <div className={cn(styles.undefined_spacer11)} />
          <div id="Status_Card_imgBlock" className={cn(styles.flex3_item2)}>
            <div
            id="Status_Card_imgBlock1"
              className={cn(styles.group, styles.group_layout)}
              onClick={() => {
                // alert('It is clickable')
              }}>
              <div
              id="Status_Card_imgBackGround"
                style={{ '--color': props.ic_background }}
                className={cn(styles.ic_background, styles.ic_background_layout)}
              />
              <img
              id="Status_Card_img"
                src={props.ic}
                alt="1933"
                className={cn(styles.status_grp_ic, styles.status_grp_ic_layout)}
              />
            </div>
          </div>
        </div>

        <div
        id="Status_Card_progress1name"
          className={cn(styles.small_text_body, styles.small_text_body_layout)}>
          {props.progress1name}
        </div>

        <div  id="Status_progressBar1_block" className={cn(styles.flex6, styles.flex6_layout)}>
          <div id="Status_progressBar1_block1" className={cn(styles.flex6_item)}>
            <div id="Status_progressBar1_innerBlock" className={cn(styles.block12, styles.block12_layout)}>
              <div id="Status_progressBar1" className={cn(styles.group3, styles.group3_layout)}>
                <div
                id="Status_progressBar1_box"
                  style={{ '--color':"#edeff1ff" }}
                  className={cn(styles.box8, styles.box8_layout)}
                />
                <div
                id="Status_progressBar1_color"
                  style={{ '--color': props.progress1color?props.progress1color:"#DE6421", width: props.progress1percent+'%' ,maxWidth:"100%",minWidth:"0%"}}
                  className={cn(styles.box9, styles.box9_layout)}
                />
              </div>
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div id="Status_progressBar_progress1percent" className={cn(styles.text_body2, styles.text_body2_layout, styles.w20)}>
            {props.progress1percent}
          </div>
        </div>

        <div
         id="Status_Card_progress2name"
          className={cn(
            styles.small_text_body,
            styles.small_text_body_layout1
          )}>
          {props.progress2name}
        </div>

        <div id="Status_progressBar2_block" className={cn(styles.block13, styles.block13_layout)}>
          <div id="Status_progressBar2_block1" className={cn(styles.block13_item)}>
            <div id="Status_progressBar2_innerBlock"  className={cn(styles.block14, styles.block14_layout)}>
              <div id="Status_progressBar2" className={cn(styles.group7, styles.group7_layout)}>
                <div className={cn(styles.box81, styles.box81_layout)} />
                <div
                 id="Status_progressBar2_color"
                  style={{ '--color':props.progress2color?props.progress2color: "#8E54E9", width: props.progress2percent+'%',maxWidth:"100%",minWidth:"0%"}}
                  className={cn(styles.box10, styles.box10_layout)}
                />
              </div>
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div id="Status_progressBar_progress2percent" className={cn(styles.text_body2, styles.text_body2_layout,styles.w20)}>
            {props.progress2percent}
          </div>
        </div>

        <div
         id="Status_Card_progress3name"
          className={cn(
            styles.small_text_body,
            styles.small_text_body_layout2
          )}>
          {props.progress3name}
        </div>

        <div id="Status_progressBar3_block" className={cn(styles.flex7, styles.flex7_layout)}>
          <div id="Status_progressBar3_block1" className={cn(styles.flex7_item)}>
            <div id="Status_progressBar3_innerBlock"  className={cn(styles.block15, styles.block15_layout)}>
              <div id="Status_progressBar3" className={cn(styles.group8, styles.group8_layout)}>
                <div className={cn(styles.box82, styles.box82_layout)} />
                <div
                 id="Status_progressBar3_color"
                  style={{'--color': props.progress3color?props.progress3color:"#E3324C", width: props.progress3percent+'%',maxWidth:"100%",minWidth:"0%"}}
                  className={cn(styles.box11, styles.box11_layout)}
                />
              </div>
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div id="Status_progressBar_progress3percent" className={cn(styles.text_body2, styles.text_body2_layout,styles.w20)}>
            {props.progress3percent}
          </div>
        </div>
      </div>
    // </div>
  );
}

StatusComponent.inStorybook = true;
